import React from "react";
import { ShopCardStyle } from "./ShopCardStyle";
export const OnlineShops = ({ shopList: shopData }) => {
  const roundValue = (number) => {
    const formattedNumber = number % 1 === 0 ? parseInt(number) : number;
    return formattedNumber;
  };
  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 panel-body">
      {shopData?.dt?.map((product) => (
        <>
        <ShopCardStyle {...product} />
        </>
      ))}
    </div>
  );
};
